<template>
  <div class="customer-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $tc("funders.finance", 2) }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="dashboard">
            {{ $t("general.home") }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">
            {{ $tc("funders.finance", 2) }}
          </router-link>
        </li>
      </ol>
      <div class="page-actions row">
        <div class="col-xs-2 mr-4">
          <base-button
            v-show="totalFunders || filtersApplied"
            :outline="true"
            :icon="filterIcon"
            size="large"
            color="theme"
            right-icon
            @click="toggleFilter"
          >
            {{ $t("general.filter") }}
          </base-button>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-show="showFilters" class="filter-section">
        <div class="row">
          <div class="col-sm-4">
            <label class="form-label">{{ $t("funders.display_name") }}</label>
            <base-input
              v-model="filters.display_name"
              type="text"
              name="name"
              autocomplete="off"
            />
          </div>
          <div class="col-sm-4">
            <label class="form-label">{{ $t("funders.contact_name") }}</label>
            <base-input
              v-model="filters.contact_name"
              type="text"
              name="address_name"
              autocomplete="off"
            />
          </div>
          <div class="col-sm-4">
            <label class="form-label">{{ $t("funders.phone") }}</label>
            <base-input
              v-model="filters.phone"
              type="text"
              name="phone"
              autocomplete="off"
            />
          </div>
          <label class="clear-filter" @click="clearFilter">{{
            $t("general.clear_all")
          }}</label>
        </div>
      </div>
    </transition>

    <div
      v-cloak
      v-show="showEmptyScreen"
      class="col-xs-1 no-data-info"
      align="center"
    >
      <astronaut-icon class="mt-5 mb-4" />
      <div class="row" align="center">
        <label class="col title">{{ $t("funders.no_funders") }}</label>
      </div>
      <div class="row">
        <label class="description col mt-1" align="center">{{
          $t("funders.list_of_funders")
        }}</label>
      </div>
    </div>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">
          {{ $t("general.showing") }}: <b>{{ funders.length }}</b>
          {{ $t("general.of") }} <b>{{ totalFunders }}</b>
        </p>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          id="select-all"
          v-model="selectAllFieldStatus"
          type="checkbox"
          class="custom-control-input"
          @change="selectAllFunders"
        />
        <label for="select-all" class="custom-control-label selectall">
          <span class="select-all-label">{{ $t("general.select_all") }} </span>
        </label>
      </div>

      <table-component
        ref="table"
        :show-filter="false"
        :data="fetchData"
        table-class="table"
      >
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
          <template slot-scope="row">
            <div class="custom-control custom-checkbox">
              <input
                :id="row.id"
                v-model="selectField"
                :value="row.id"
                type="checkbox"
                class="custom-control-input"
              />
              <label :for="row.id" class="custom-control-label" />
            </div>
          </template>
        </table-column>
        <table-column :label="$t('general.company_name')" show="company_name" />
        <table-column :label="$t('funders.display_name')" show="name" />
        <table-column :label="$t('funders.contact_name')" show="contact_name" />
        <table-column :label="$t('funders.phone')" show="phone" />
        <table-column
          :label="$t('funders.added_on')"
          sort-as="created_at"
          show="formattedCreatedAt"
        />
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span> {{ $t("funders.action") }} </span>
            <v-dropdown>
              <a slot="activator" href="#">
                <dot-icon />
              </a>
              <v-dropdown-item>
                <div class="dropdown-item" @click="viewFunderPage(row)">
                  <font-awesome-icon
                    :icon="['fas', 'eye']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.administrative_view") }}
                </div>

                <div class="dropdown-item" @click="viewFinancePage(row)">
                  <font-awesome-icon
                    :icon="['fas', 'shopping-bag']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.islamic_finance") }}
                </div>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import DotIcon from "../../components/icon/DotIcon";
import AstronautIcon from "../../components/icon/AstronautIcon";
import BaseButton from "../../../js/components/base/BaseButton";
import { request } from "http";

export default {
  components: {
    DotIcon,
    AstronautIcon,
    SweetModal,
    SweetModalTab,
    BaseButton
  },
  data() {
    return {
      advanceOption: true,
      showFilters: false,
      filtersApplied: false,
      isRequestOngoing: true,
      filters: {
        display_name: "",
        contact_name: "",
        phone: ""
      }
    };
  },
  created() {},
  computed: {
    showEmptyScreen() {
      return (
        !this.totalFunders && !this.isRequestOngoing && !this.filtersApplied
      );
    },
    filterIcon() {
      return this.showFilters ? "times" : "filter";
    },
    ...mapGetters("funder", [
      "funders",
      "selectedFunders",
      "totalFunders",
      "selectAllField"
    ]),
    selectField: {
      get: function() {
        return this.selectedFunders;
      },
      set: function(val) {
        this.selectFunder(val);
      }
    },
    selectAllFieldStatus: {
      get: function() {
        return this.selectAllField;
      },
      set: function(val) {
        this.setSelectAllState(val);
      }
    }
  },
  watch: {
    filters: {
      handler: "setFilters",
      deep: true
    }
  },
  destroyed() {
    if (this.selectAllField) {
      this.selectAllFunders();
    }
  },
  methods: {
    ...mapActions("funder", [
      "viewFunder",
      "fetchFunders",
      "selectAllFunders",
      "selectFunder",
      "setSelectAllState"
    ]),
    refreshTable() {
      this.$refs.table.refresh();
    },
    async fetchData({ page, per_page, filter, sort }) {
      let data = {
        display_name: this.filters.display_name,
        contact_name: this.filters.contact_name,
        phone: this.filters.phone,
        orderByField: sort.fieldName || "created_at",
        orderBy: sort.order || "desc",
        per_page, // Add rowsPerPage in the API request
        page
      };

      this.isRequestOngoing = true;
      let response = await this.fetchFunders(data);
      this.isRequestOngoing = false;

      return {
        data: response.data.funders.data,
        pagination: {
          totalPages: response.data.funders.last_page,
          currentPage: page,
          rowsPerPage: response.data.funders.per_page // Add rowsPerPage in the API request
        }
      };
    },
    setFilters() {
      this.filtersApplied = true;
      this.refreshTable();
    },
    clearFilter() {
      this.filters = {
        display_name: "",
        contact_name: "",
        phone: ""
      };

      this.$nextTick(() => {
        this.filtersApplied = false;
      });
    },
    toggleFilter() {
      if (this.showFilters && this.filtersApplied) {
        this.clearFilter();
        this.refreshTable();
      }

      this.showFilters = !this.showFilters;
    },
    async viewFunderPage(row) {
      this.$router.push(`/supplier/funders/${row.id}/view`);
    },
    async viewFinancePage(row) {
      this.$router.push(`/supplier/funders/${row.id}/islamic_finance`);
    }
  }
};
</script>
